// private routes
export const SEARCH_PAGE_ROUTE = '/search';
export const SAVED_SEARCH_PAGE_ROUTE = '/savedsearch/:id';
export const COLLECTION_PAGE_ROUTE = '/collection/:id';
export const DASHBOARD_ROUTE = '/dashboard';

export const ASSET_PAGE_ROUTE = '/asset/:id';
export const ASSET_VERSION_PAGE_ROUTE = '/asset/:id/v/:versionId';
export const UPLOAD_PAGE_ROUTE = '/upload';
export const USER_PROFILE_PAGE_ROUTE = '/user/profile';

export const FAVOURITES_PAGE_ROUTE = '/favorites';
export const MY_SHARES_ROUTE = '/my_shares';
export const PORTALS_PAGE_ROUTE = '/portals';
export const PORTAL_PAGE_ROUTE = '/portals/:id';
export const PORTAL_MEDIA_PAGE_ROUTE = '/portals/:id/media/:mediaId?';
export const PORTAL_EDIT_PAGE_ROUTE = '/portals/:id/edit';
export const PORTAL_EDIT_MEDIA_PAGE_ROUTE = '/portals/:id/edit/media/:mediaId?';
export const POSTS_PAGE_ROUTE = '/posts';
export const POSTS_SCHEDULED_PAGE_ROUTE = '/posts/scheduled';
export const MY_SHARES_PLAYLIST_ROUTE =
  '/my_shares/share/:shareId/playlist/:id';
export const ADMIN_JOBS_DASHBOARD_SYSTEM_PAGE_ROUTE =
  '/admin/jobs/dashboard/system';
export const ADMIN_JOBS_DASHBOARD_SYSTEM_WIDGET_PAGE_ROUTE =
  '/admin/jobs/dashboard/system/widget/:id';
export const ADMIN_JOBS_DASHBOARD_PAGE_ROUTE = '/admin/jobs/dashboard';
export const ADMIN_JOBS_HISTORY_PAGE_ROUTE = '/admin/jobs/history';
export const ADMIN_JOBS_JOB_PAGE_ROUTE = '/admin/jobs/:id';
export const ADMIN_JOBS_DASHBOARD_WIDGET_PAGE_ROUTE =
  '/admin/jobs/dashboard/widget/:id';
export const ADMIN_JOBS_DASHBOARD_JOB_PAGE_ROUTE = '/admin/jobs/dashboard/:id';
export const ADMIN_JOBS_HISTORY_JOB_PAGE_ROUTE = '/admin/jobs/history/:id';
export const ADMIN_JOBS_HISTORY_SUBJOBS_PAGE_ROUTE =
  '/admin/jobs/history/:id/subjobs';
export const ADMIN_JOBS_HISTORY_SUBJOBS_JOB_PAGE_ROUTE =
  '/admin/jobs/history/:parentId/subjobs/:id';
export const ADMIN_AI_METADATA_ENRICHMENT_PAGE_ROUTE =
  '/admin/ai_metadata_enrichment';
export const ADMIN_AI_METADATA_ENRICHMENT_SUBJOBS_PAGE_ROUTE =
  '/admin/ai_metadata_enrichment/:id/subjobs';
// private routes
export const ADMIN_FACE_RECOGNITION_ROUTE = '/admin/face_recognition';
export const ADMIN_FACE_RECOGNITION_PERSON_ROUTE =
  '/admin/face_recognition/persons/:id';
export const ADMIN_STORAGE_PAGE_ROUTE = '/admin/storages/:id';
export const ADMIN_TRANSCODER_PAGE_ROUTE = '/admin/transcoders/:id';
export const ADMIN_USER_PAGE_ROUTE = '/admin/users/:id';
export const ADMIN_GROUP_PAGE_ROUTE = '/admin/groups/:id';
export const ADMIN_TEAM_PAGE_ROUTE = '/admin/teams/:id';
export const ADMIN_ROLE_GROUP_PAGE_ROUTE = '/admin/role_groups/:id';
export const ADMIN_ACL_TEMPLATE_ROUTE = '/admin/acl_templates/:id';

export const ADMIN_METADATA_VIEW_PAGE_ROUTE = '/admin/metadata/views/:id';

export const ADMIN_RECYCLE_BIN_PAGE_ASSETS_ROUTE = '/admin/recyclebin';
export const ADMIN_RECYCLE_BIN_PAGE_COLLECTIONS_ROUTE =
  '/admin/recyclebin/collections';
export const ADMIN_RECYCLE_BIN_PAGE_FORMATS_ROUTE = '/admin/recyclebin/formats';
export const ADMIN_RECYCLE_BIN_PAGE_FILES_ROUTE = '/admin/recyclebin/files';
export const ADMIN_SHARE_MANAGEMENT_PAGE_ROUTE = '/admin/share_management';
export const ADMIN_CUSTOM_ACTIONS_GENERAL_ROUTE =
  '/admin/site_settings/custom_actions/:context/:id/general';
export const ADMIN_CUSTOM_ACTIONS_ACLS_ROUTE =
  '/admin/site_settings/custom_actions/:context/:id/acls';
export const ADMIN_EXPORT_LOCATIONS_GENERAL_ROUTE =
  '/admin/export_locations/:id/general';
export const ADMIN_EXPORT_LOCATIONS_ACLS_ROUTE =
  '/admin/export_locations/:id/acls';
export const ADMIN_IDENTITY_PROVIDERS_LIST_ROUTE =
  '/admin/site_settings/identity_providers';
export const ADMIN_IDENTITY_PROVIDER_ROUTE =
  '/admin/site_settings/identity_providers/:id';

export const ADMIN_ISG_CLUSTER_SETTINGS_ROUTE =
  '/admin/isg/cluster/:id/settings';

export const ADMIN_BILLING_DETAILS_ROUTE = '/admin/billing/details';

// public routes
export const SHARE_ROOT_ROUTE = '/share';
export const SHARE_ASSET_PAGE_ROUTE = '/share/assets/:id';
export const SHARE_ASSET_VERSION_PAGE_ROUTE = '/share/assets/:id/v/:versionId';
export const SHARE_COLLECTION_PAGE_ROUTE = '/share/collections/:id';
export const SHARE_PORTAL_PAGE_ROUTE = '/share/portals/:id';
export const SHARE_PORTAL_MEDIA_PAGE_ROUTE =
  '/share/portals/:id/media/:mediaId?';

export const LOGIN_PAGE_ROUTE = '/login';

export const LOGOUT_PAGE_ROUTE = '/logout';
export const PASSWORD_FORGOT_PAGE_ROUTE = '/password/forgot';
export const PASSWORD_CONFIRM_PAGE_ROUTE = '/password/confirm';
export const PASSWORD_RESET_PAGE_ROUTE = '/password/reset/:hash';
export const INVITE_PAGE_ROUTE = '/invite/:hash';
export const INVITE_DOMAIN_PAGE_ROUTE = '/invite';
export const INVITE_REGISTER_PAGE_ROUTE = '/invite_link/validate';
export const SIGNUP_PAGE_ROUTE = '/trial_signup';
export const MANAGED_SIGNUP_PAGE_ROUTE = '/signup';
export const REGISTRATIONS_VERIFY_PAGE_ROUTE = '/registrations/verify/:hash';

export const OAUTH_AUTHORIZE_PAGE_ROUTE = '/oauth/authorize';

export const topTitleBarRoutes = new Set([
  COLLECTION_PAGE_ROUTE,
  ASSET_VERSION_PAGE_ROUTE,
  ASSET_PAGE_ROUTE,
  SEARCH_PAGE_ROUTE,
  FAVOURITES_PAGE_ROUTE,
  SAVED_SEARCH_PAGE_ROUTE,
  SHARE_COLLECTION_PAGE_ROUTE,
  SHARE_ASSET_VERSION_PAGE_ROUTE,
  SHARE_ASSET_PAGE_ROUTE,
]);

export const lightThemeRoutes = new Set([
  LOGIN_PAGE_ROUTE,
  PASSWORD_FORGOT_PAGE_ROUTE,
  PASSWORD_CONFIRM_PAGE_ROUTE,
  PASSWORD_RESET_PAGE_ROUTE,
  INVITE_PAGE_ROUTE,
  INVITE_REGISTER_PAGE_ROUTE,
  INVITE_DOMAIN_PAGE_ROUTE,
  SIGNUP_PAGE_ROUTE,
  MANAGED_SIGNUP_PAGE_ROUTE,
  REGISTRATIONS_VERIFY_PAGE_ROUTE,
  OAUTH_AUTHORIZE_PAGE_ROUTE,
]);

export const routesWithPlayer = new Set([
  ASSET_PAGE_ROUTE,
  SHARE_ASSET_PAGE_ROUTE,
  ASSET_VERSION_PAGE_ROUTE,
  SHARE_ASSET_VERSION_PAGE_ROUTE,
]);
